import React from "react";
import { Edit, Eye } from "lucide-react";

export default function BeneficiosTableComponent({
    data = [],
    metaPaginacion = {},
    onPageChange,
    perPage = 10,
    onPerPageChange,
    handleEditarItem,
    handleVerDetalle,
}) {
    const formatDate = (value) => {
        if (!value) return "-";
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return value;
        return date.toLocaleString("es-PY", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    return (
        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
            <div className="overflow-x-auto">
                <table className="w-full">
                    <thead className="bg-gray-50 border-b border-gray-200">
                        <tr>
                            <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
                            <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Beneficio</th>
                            <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Orden</th>
                            <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Especial</th>
                            <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Locales</th>
                            <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actualizado</th>
                            <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
                        </tr>
                    </thead>

                    <tbody className="bg-white divide-y divide-gray-200">
                        {data?.map((item) => (
                            <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm font-medium text-gray-700">{item?.id || "-"}</div>
                                </td>

                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="font-medium text-gray-900 max-w-[260px] truncate">{item?.nombre || "-"}</div>
                                </td>

                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm text-gray-700">{item?.orden || "-"}</div>
                                </td>

                                <td className="px-6 py-4 whitespace-nowrap">
                                    <span
                                        className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${item?.beneficio_especial === "1" || item?.beneficio_especial === 1
                                            ? "bg-emerald-100 text-emerald-700"
                                            : "bg-gray-100 text-gray-700"}`}
                                    >
                                        {item?.beneficio_especial === "1" || item?.beneficio_especial === 1 ? "Si" : "No"}
                                    </span>
                                </td>

                                <td className="px-6 py-4">
                                    {item?.locales?.length > 0 ? (
                                        <div className="max-w-[320px]">
                                            <div className="text-sm font-medium text-gray-800">{item.locales.length} locales</div>
                                            <div className="text-xs text-gray-600 truncate">
                                                {item.locales
                                                    .map((local) => local?.nombre_fantasia || local?.razon_social)
                                                    .filter(Boolean)
                                                    .join(", ")}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="text-sm text-gray-500">Sin locales</div>
                                    )}
                                </td>

                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm text-gray-700">{formatDate(item?.updated_at)}</div>
                                </td>

                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="flex items-center gap-2">
                                        <button
                                            className="p-1 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
                                            title="Ver detalle"
                                            onClick={() => handleVerDetalle(item)}
                                        >
                                            <Eye className="w-4 h-4 text-gray-500" />
                                        </button>

                                        <button
                                            className="p-1 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
                                            title="Editar"
                                            onClick={() => handleEditarItem(item)}
                                        >
                                            <Edit className="w-4 h-4 text-gray-500" />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {data.length === 0 && (
                <div className="text-center py-12">
                    <div className="text-gray-500">No hay beneficios para mostrar.</div>
                </div>
            )}

            {metaPaginacion && metaPaginacion.total > 0 && (
                <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4">
                            <div className="text-sm text-gray-700">
                                Mostrando <span className="font-medium">{((metaPaginacion.current_page - 1) * metaPaginacion.per_page) + 1}</span> a{" "}
                                <span className="font-medium">
                                    {Math.min(metaPaginacion.current_page * metaPaginacion.per_page, metaPaginacion.total)}
                                </span> de <span className="font-medium">{metaPaginacion.total}</span> beneficios
                            </div>

                            <div className="flex items-center gap-2">
                                <span className="text-sm text-gray-600">Mostrar:</span>
                                <select
                                    value={perPage}
                                    onChange={(e) => onPerPageChange && onPerPageChange(Number(e.target.value))}
                                    className="border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                                >
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={15}>15</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                </select>
                                <span className="text-sm text-gray-600">por página</span>
                            </div>
                        </div>

                        <div className="flex items-center gap-4">
                            <div className="text-sm text-gray-700">
                                Página <span className="font-medium">{metaPaginacion.current_page}</span> de{" "}
                                <span className="font-medium">{metaPaginacion.last_page}</span>
                            </div>

                            <div className="flex items-center gap-2">
                                <button
                                    onClick={() => onPageChange && onPageChange(1)}
                                    disabled={metaPaginacion.current_page === 1}
                                    className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    Primera
                                </button>
                                <button
                                    onClick={() => onPageChange && onPageChange(metaPaginacion.current_page - 1)}
                                    disabled={metaPaginacion.current_page === 1}
                                    className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    Anterior
                                </button>
                                <button
                                    onClick={() => onPageChange && onPageChange(metaPaginacion.current_page + 1)}
                                    disabled={metaPaginacion.current_page === metaPaginacion.last_page}
                                    className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    Siguiente
                                </button>
                                <button
                                    onClick={() => onPageChange && onPageChange(metaPaginacion.last_page)}
                                    disabled={metaPaginacion.current_page === metaPaginacion.last_page}
                                    className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    Última
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
